import {Select as MantineSelect} from '@mantine/core';

import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
  focused: boolean;
}

interface InputProps {
  error?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};

  .input {
    height: 100%;
    outline: none;
    border-radius: 3px;
    height: 45px;

    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;

    .mantine-Select-option {
      &:hover {
        background-color: red;
      }
    }
  }

  .mantine-Select-input::placeholder {
    color: ${(props) => props.theme.colors.opacityText};
    opacity: 0.5;
  }
`;

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.theme.colors.text};
`;

export const Label = styled.label<InputProps>`
  font-weight: 600;
  color: ${(props) =>
    props.error ? props.theme.colors.error : props.theme.colors.text};
  cursor: pointer;
`;

export const StyledSelect = styled(MantineSelect).attrs<InputProps>(
  (props) => ({
    styles: {
      root: {width: '100%'},
      wrapper: {minHeight: 30},
      rightSection: {display: 'none'},
      selected: {
        backgroundColor: props.theme.colors.primaryLight,
        color: props.theme.colors.primary,
      },
      values: {width: '100%'},
      options: {
        backgroundColor: props.theme.colors.card,
        color: props.theme.colors.text,
      },
      input: {
        outline: 'none',
        color: props.theme.colors.text,
        fontWeight: 600,
        padding: 10,
        backgroundColor: props.theme.colors.background,
        borderRadius: 4,
        border: `1px solid ${
          props.error
            ? props.theme.colors.error
            : props.theme.colors.inputBorder
        }`,
      },
    },
    classNames: {input: 'input'},
  }),
)``;
